/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_EmptyInputs */

const en_admin_settings_custom_empty = /** @type {(inputs: Admin_Settings_Custom_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No custom configs yet. Click "Add" to create one.`)
};

const zh_admin_settings_custom_empty = /** @type {(inputs: Admin_Settings_Custom_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无自定义配置，点击「添加」新建一条。`)
};

/**
* | output |
* | --- |
* | "No custom configs yet. Click \"Add\" to create one." |
*
* @param {Admin_Settings_Custom_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_empty = /** @type {((inputs?: Admin_Settings_Custom_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_custom_empty(inputs)
	return zh_admin_settings_custom_empty(inputs)
});
export { admin_settings_custom_empty as "admin.settings.custom.empty" }